<template>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <input type="checkbox" class="form-control margin-bottom" v-model="item.value" v-bind:placeholder="item.placeholder" v-bind:name="item.name" v-bind:disabled="item.disabled" @change="update">
        <div v-for="error in item.errors" v-bind:class="{'margin-left': item.type=='checkbox'}" class="to-up" id="errors">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default{
    name: 'emt-checkbox',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function (event) {
            var self = this
            self.$emit('email', event.target.value)
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-checkbox.vue?d41eab66